import { createSlice } from '@reduxjs/toolkit';

type globalTooltipState = {
  // 전체 툴팁 ON / OFF 시 사용 (해당 기능이 구현된 구현체는 아직 앱에 없음)
  isShowAnyTooltip: boolean;

  // 앱 다운로드 유도 모달
  isShowDownloadAppModal: boolean;
  downloadAppTooltipHeight: number;

  // 마켓 탭 클릭 유도 툴팁
  isShowWhenInPluvaTooltip: boolean;
  isShowWhenInPartnerTooltip: boolean;
  isShowWhenInOpenMarketTooltip: boolean;
};

const initialState: globalTooltipState = {
  isShowAnyTooltip: true,
  isShowDownloadAppModal: false,
  downloadAppTooltipHeight: 74,
  isShowWhenInPluvaTooltip: true,
  isShowWhenInPartnerTooltip: true,
  isShowWhenInOpenMarketTooltip: true,
};

export const globalTooltipSlice = createSlice({
  name: 'globalTooltip',
  initialState,
  reducers: {
    closeAllTooltip: (state) => {
      state.isShowAnyTooltip = false;
    },
    showAllTooltip: (state) => {
      state.isShowAnyTooltip = true;
    },
    closeDownloadAppModal: (state) => {
      state.isShowDownloadAppModal = false;
    },
    showDownloadAppModal: (state) => {
      state.isShowDownloadAppModal = true;
    },
    closeWhenInPluvaTooltip: (state) => {
      state.isShowWhenInPluvaTooltip = false;
    },
    closeWhenInPartnerTooltip: (state) => {
      state.isShowWhenInPartnerTooltip = false;
    },
    closeWhenInOpenMarketTooltip: (state) => {
      state.isShowWhenInOpenMarketTooltip = false;
    },
  },
});
